import { api } from './client';
import type { SubmissionDTO, PaginatedResult } from './types';

export interface SubmissionFilters {
  page?: number;
  limit?: number;
  search?: string;
  from?: string;
  to?: string;
  isRead?: boolean;
}

function buildQuery(filters: SubmissionFilters): string {
  const params = new URLSearchParams();
  if (filters.page) params.set('page', String(filters.page));
  if (filters.limit) params.set('limit', String(filters.limit));
  if (filters.search) params.set('search', filters.search);
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  if (filters.isRead !== undefined) params.set('isRead', String(filters.isRead));
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const submissionsApi = {
  list: (formId: string, filters: SubmissionFilters = {}) =>
    api.get<PaginatedResult<SubmissionDTO>>(`/forms/${formId}/submissions${buildQuery(filters)}`),

  get: (formId: string, id: string) =>
    api.get<{ submission: SubmissionDTO }>(`/forms/${formId}/submissions/${id}`),

  toggleRead: (formId: string, id: string) =>
    api.patch<{ submission: SubmissionDTO }>(`/forms/${formId}/submissions/${id}/read`),

  delete: (formId: string, id: string) =>
    api.delete<{ message: string }>(`/forms/${formId}/submissions/${id}`),

  exportCsv: async (formId: string) => {
    const res = await fetch(`/api/forms/${formId}/submissions/export`, { credentials: 'include' });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `submissions-${formId}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  },
};
